jQuery(document).ready(function() {
    jQuery('#event-list-toggle > .toggle-button:not(.selected)').click(function(){
        var filter = jQuery(this).attr('event-list-filter');
        var url = jQuery('#events_url').val();

        if(filter == 'past'){
            if (url.indexOf('?') > -1){
                url = url + '&past=1';
            }else{
                url = url + '?past=1';
            }
        }
        window.location = url;
    });
});